export const globalInitialState = {
    loggedIn: false,
    globalLoading: true,
    globalAuthLoading: true,
    globalCarousel: [],
    globalRecentEvents: [],
};